<template>
	<div v-if="baseData.length > 0">
		<base-card title="血糖平均值（mmol/L）" class="mt-28">
			<numberCard :list="numberList" />
			<textCard
				class="mt-40"
				:list="[
                            '根据医学指南：',
                            '空腹血糖目标值为：4.4~7.0 mmol/L',
                            '餐后血糖目标值为：4.4~10 mmol/L',
                            '随机血糖目标值为：4.4~10 mmol/L',
                            '如有疑问，请咨询医生。',
                        ]"
			/>
		</base-card>
		<base-card title="血糖趋势" class="mt-28">
			<div class="chars_title mt-28 "><div>血糖（mmol/L）</div><div class="tag tag_primart">空腹</div></div>
			<IndicatorChart ref="chart1" container="chart1" />
			<div class="chars_title mt-28 "><div>血糖（mmol/L）</div><div class="tag tag_blue">餐后</div></div>
			<IndicatorChart ref="chart2" container="chart2" />
			<div class="chars_title mt-28 "><div>血糖（mmol/L）</div><div class="tag tag_warry">随机</div></div>
			<IndicatorChart ref="chart3" container="chart3" />
		</base-card>
		<base-card title="血糖达标情况" class="mt-28">
			<div class="echars-row" id="mainPie2"></div>
			<div class="number_card"
				>您本月血糖测量天数为 <span>{{ detail.measureQuantity }}</span> 天</div
			>
			<div class="number_card"
				>血糖达标次数为 <span>{{ detail.sugarStandard }}</span> 次， 占总测量次数的比例为
				<span>{{ detail.sugarStandardScale }}</span> %</div
			>
		</base-card>
		<remind title="血糖温馨提示" :list="tips" />
	</div>
	<van-empty
		v-else
		description="您本月记录的数据较少，无法为您做出分析和建议，建议您从今天开始，坚持测量血糖并上传数据，我们将在下月1日为您进行分析、出具血糖数据报告"
	/>
</template>
<script>
import numberCard from './report-number-card.vue'
import textCard from './report-deatil-text.vue'
import remind from './report-detail-remind.vue'
import IndicatorChart from '../../indicator/components/indicator-chart.vue'
export default {
    name: 'reportSugar',
    components: { numberCard, textCard, remind, IndicatorChart },
    props: {
        detail: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        baseData () {
            return this.detail.bloodSugarRecordList || []
        },
        patient () {
            return this.detail.patientDetail || {}
        },
        numberList () {
            const { emptyStomach, afterDinner, randomScanl } = this.detail
            let colorObj = {
                1: '#14C9C9',
                2: '#F7BA1E',
                3: '#FA5151'
            }
            return [
                { label: '空腹', value: emptyStomach, color: colorObj[this.emptyStatus] },
                { label: '餐后', value: afterDinner, color: colorObj[this.afterStatus] },
                { label: '随机', value: randomScanl, color: colorObj[this.randomStatus] }
            ]
        },
        emptyStatus () {
            const { emptyStomach } = this.detail
            let ret = 1
            if (emptyStomach < 4.4) {
                ret = 2
            }
            if (emptyStomach > 7) {
                ret = 3
            }
            return ret
        },
        afterStatus () {
            const { afterDinner } = this.detail
            let ret = 1
            if (afterDinner < 4.4) {
                ret = 2
            }
            if (afterDinner > 10) {
                ret = 3
            }
            return ret
        },
        randomStatus () {
            const { randomScanl } = this.detail
            let ret = 1
            if (randomScanl < 4.4) {
                ret = 2
            }
            if (randomScanl > 10) {
                ret = 3
            }
            return ret
        },
        tips () {
            let ret = [
                '忽高忽低的血糖，对身体造成的伤害较大，建议您：',
                '严格控制饮食：摄入低糖、低脂食物，避免食用高糖水果及饮品等，少食多餐；',
                '加强体育锻炼：尽量每周至少运动3次，每次30分钟以上；',
                '降糖药物治疗：遵医嘱坚持按时按量、规律用药，请勿自行减量或停药；',
                '持续测量血糖：需利用血糖仪测量空腹及餐后血糖。您需要根据自身具体情况，及时询问医生调整治疗方案。',
                '以上内容仅供参考，不作为诊疗依据。'
            ]
            if (this.emptyStatus === 1 && this.afterStatus === 1 && this.randomStatus === 1) {
                ret = [
                    '平稳控制血糖有助于减少并发症的发生。',
                    '1）糖尿病是一种慢性病，保持良好的生活习惯对控制血糖非常重要。饮食上，建议控制主食量，不要吃过甜、过肥、过咸的食物；运动上，尽量每周至少运动3次，每次30分钟以上。',
                    '2）测量血糖有助于您掌握自己的血糖情况，也可以帮助医生了解您的血糖变化，及时调整治疗方案，请继续坚持测量血糖。',
                    '以上内容仅供参考，不作为诊疗依据。'
                ]
            }
            return ret
        }
    },
    methods: {
        init () {
            if (this.baseData.length === 0) {
                return
            }

            let data1 = this.initData(1)
            let data2 = this.initData(2)
            let data3 = this.initData(3)

            let obj = {
                markArea: {
                    itemStyle: {
                        color: 'rgba(31, 35, 41, 0.1)'
                    },
                    data: []
                },
            }
            this.$nextTick(() => {
                this.$refs.chart1.start({
                    ...obj,
                    datas: [
                        { name: '空腹', color: '#14c9c9', data: data1.val }
                    ],
                    xAxis: data1.xAxis
                })
                this.$refs.chart2.start({
                    ...obj,
                    datas: [
                        { name: '餐后', color: '#5285f4', data: data2.val }
                    ],
                    xAxis: data2.xAxis
                })
                this.$refs.chart3.start({
                    ...obj,
                    datas: [
                        { name: '随机', color: '#f7ba1e', data: data3.val }
                    ],
                    xAxis: data3.xAxis
                })
            })



            this.initPie()
        },
        initData (type) {
            let arr = this.baseData.filter(v => v.sugarType === type)
            let xAxis = []
            let val = []
            arr.map(v => {
                xAxis.push(this.$moment(v.measureTime).format('MM-DD'))
                val.push(v.bloodSugar)
            })
            return { xAxis, val }
        },
        initPie () {
            let mainPie = this.$echarts.init(document.getElementById('mainPie2'))
            console.log(mainPie)
            window.addEventListener('resize', function () {
                mainPie.resize()
            })
            const { sugarStandard, bloodSugarRecordList } = this.detail
            let option = {
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} ({d}%)'
                },
                legend: {
                    show: false
                },

                series: [{
                    name: '',
                    type: 'pie',
                    radius: ['40%', '60%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 2,
                    },
                    label: {
                        show: true,
                        alignTo: 'edge',
                        formatter: '{name|{b} {d}%}\n',
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        rich: {
                            time: {
                                fontSize: 10,
                                color: '#999'
                            }
                        }
                    },

                    labelLine: {
                        length: 15,
                        length2: 0,
                        maxSurfaceAngle: 80
                    },
                    labelLayout: function (params) {
                        const isLeft = params.labelRect.x < mainPie.getWidth() / 2;
                        const points = params.labelLinePoints;
                        // Update the end point.
                        points[2][0] = isLeft
                            ? params.labelRect.x
                            : params.labelRect.x + params.labelRect.width;
                        return {
                            labelLinePoints: points,
                        };
                    },
                    data: [
                        {
                            value: parseFloat(bloodSugarRecordList.length - sugarStandard), name: '未达标', itemStyle: {
                                color: '#F7BA1E'
                            }
                        },
                        {
                            value: sugarStandard, name: '达标', itemStyle: {
                                color: '#14C9C9'
                            }
                        },
                    ]
                }],
            }
            // 使用刚指定的配置项和数据显示图表。
            console.log(option)
            mainPie.setOption(option)
        }
    }
}
</script>
<style lang="less" scoped>
.number_card {
	font-size: 26px;
	color: #1f2329;
	vertical-align: bottom;
	text-align: center;
	span {
		font-size: 36px;
		color: @primary;
	}
}
.chars_title {
	display: flex;
	font-size: 18px;
	color: #8f959e;
	align-items: center;
	justify-content: space-between;

	margin-bottom: 20px;
	.tag {
		width: 76px;
		height: 44px;
		line-height: 44px;
		border-radius: 7px;
		color: #ffffff;
		text-align: center;
		font-size: 24px;
	}
	.tag_primart {
		background-color: #14c9c9;
	}
	.tag_blue {
		background-color: #5285f4;
	}
	.tag_warry {
		background-color: #f7ba1e;
	}
}
.echars-row {
	width: 100%;
	height: 300px;
}
.noData {
	height: 246px;
	background-image: url('../../../assets/img/none-charts.png');
	background-size: 100% 100%;
}
</style>